import styled from "styled-components"

import {Card, Hr} from "@irati/ui/src/Layout"
import {twoPxShadow} from "@irati/ui/src/global/elevation"
export const StyledCard = styled(Card)`
  padding: 20px;
  ${twoPxShadow};
  margin-bottom: 30px;
`
export const StyledHr = styled(Hr)`
  margin: 0;
`
